import Repo from './Repo.js'

export default class GroupationRepository extends Repo {
  constructor () {
    super('groupations')
  }

  all (q) {
    return super.all(q)
  }

  store (data) {
    return super.store(data)
  }

  update (id, data) {
    return super.update(id, data)
  }

  get (id, include) {
    return super.get(id, {include: include})
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (q) {
    return super.paginate(q)
  }

  getProducts(id, include, data) {
    if(data) {
      data.orderBy = 'created_at,desc';
    }
    if(include) {
      data.include = include
    }
    return this.http.get(this.resource + '/' + id + '/products', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  attachProduct(id, product_id, data){
    return this.http.post(this.resource + '/' + id + '/products/' + product_id, data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  attachProductSize(id, product_size_id, data){
    return this.http.post(this.resource + '/' + id + '/product-sizes/' + product_size_id, data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  detachProduct(id, product_id, data){
    return this.http.delete(this.resource + '/' + id + '/products/' + product_id).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  detachProductSize(id, product_size_id){
    return this.http.delete(this.resource + '/' + id + '/product-sizes/' + product_size_id).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  userCheckoutFormGetProducts(id, q){
    return this.http.get(this.resource + '/' + id + '/products?q=' + q).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }
}
